export const en = {
  inputElements: {
    typeElements: {
      input: 'Input',
      typography: 'Typography',
      layout: 'Layout',
      action: 'Action',
    },
  },
  panels: {
    Component: 'Component',
    Layer: 'Layer',
    Design: 'Design',
  },
  designPanel: {
    title: 'Basic Appearance',
    fontFamily: 'Font Family',
    fontSize: 'Font Size',
    labelFormat: 'Label Format',
    labelAllignment: 'Label Alignment',
    textColor: 'Text Color',
    backgroundColor: 'Background Color',
  },
  componentPanel: {
    searchPlaceholder: 'Search components...',
  },
  tabPreviewForm: {
    'Form Definition': 'Form Definition',
    'Form Preview': 'Form Preview',
  },
}
